'use client';

import { ConfigProvider, theme } from 'antd';

import { useTheme } from '../hooks';

export default function AntdConfigProvider(
  { children } : { children: React.ReactNode },
) {
  const { theme: selectedTheme } = useTheme();

  let algorithm = theme.defaultAlgorithm;

  if (selectedTheme === 'dark') {
    algorithm = theme.darkAlgorithm;
  }

  return (
    <ConfigProvider theme={{
      algorithm,
    }}
    >
      {children}
    </ConfigProvider>
  );
}
